module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.service && _vm.occurrence) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "is-half column"
  }, [_c('service', {
    attrs: {
      "service": _vm.service
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "is-half column"
  }, [_c('occurrences-simple', {
    attrs: {
      "service": _vm.service,
      "occurrence": _vm.occurrence.id
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (parseInt(_vm.$store.state.config.user.level) < 4) ? _c('occurrences-simple', {
    attrs: {
      "service": _vm.service,
      "occurrence": _vm.occurrence.id,
      "internal": true
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('article', {
    staticClass: "tile is-child box"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Ticket "), (parseInt(_vm.occurrence.type) == 2) ? _c('span', [_vm._v("Internal")]) : _vm._e(), _vm._v(" - " + _vm._s(_vm.occurrence.team_user !== null ? _vm.occurrence.team_user.name : 'Not Allocated'))]), _vm._v(" "), _c('div', {
    staticClass: "columns is-multiline"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "card is-fullwidth",
    staticStyle: {
      "box-shadow": "0 2px 3px #A71C20, 0 0 0 1px #A71C20"
    }
  }, [_c('header', {
    staticClass: "card-header is-primary",
    staticStyle: {
      "box-shadow": "0 1px 0px #A71C20, 0 0 0 0px #A71C20",
      "background-color": "#A71C20",
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('p', {
    staticClass: "card-header-title is-primary",
    staticStyle: {
      "color": "#FFFFFF"
    }
  }, [_vm._v("#" + _vm._s(_vm.occurrence.id) + " - " + _vm._s(_vm.occurrence.subject))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.occurrence.status == 3 && (parseInt(_vm.$store.state.config.user.level) == 3)),
      expression: "occurrence.status == 3 && (parseInt($store.state.config.user.level) == 3)"
    }],
    staticClass: "button is-warning is-small",
    staticStyle: {
      "margin-right": "0.5rem"
    },
    on: {
      "click": _vm.reopenOccurrence
    }
  }, [_vm._v("Reopen")])]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('article', {
    staticClass: "media"
  }, [_c('p', [_c('b', [_vm._v("Department:")]), _vm._v(" " + _vm._s(_vm.parseDepartament(_vm.occurrence.departament))), _c('br'), _vm._v(" "), _c('b', [_vm._v("Status:")]), _vm._v(" " + _vm._s(_vm.parseStatus(_vm.occurrence.status))), _c('br')])]), _vm._v(" "), _c('article', {
    staticClass: "media"
  }, [_c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.occurrence.occurrence)
    }
  })]), _vm._v(" "), (_vm.occurrence.files.length > 0) ? _c('article', {
    staticClass: "media"
  }, [(_vm.showFiles == false) ? [_c('a', {
    staticClass: "button",
    on: {
      "click": _vm.loadFiles
    }
  }, [_vm._m(0), _c('span', [_vm._v("Show Files (" + _vm._s(_vm.occurrence.files.length) + ")")])])] : [_c('div', {
    staticClass: "columns is-multiline"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.occurrence_files), function(file) {
    return [_c('div', {
      staticClass: "column is-12",
      staticStyle: {
        "text-align": "center"
      }
    }, [(file['ext'].toLowerCase() == 'jpg' || file['ext'].toLowerCase() == 'gif' || file['ext'].toLowerCase() == 'png' || file['ext'].toLowerCase() == 'jpeg') ? [_c('a', {
      staticStyle: {
        "border-bottom": "none"
      },
      attrs: {
        "href": file['url'],
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": file['url'],
        "alt": "",
        "width": "90%"
      }
    })])] : [_c('a', {
      staticStyle: {
        "border-bottom": "none"
      },
      attrs: {
        "href": file['url'],
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-file-o fa-4",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n                                " + _vm._s(file['name']) + "\n                              ")])]], 2), _vm._v(" "), _c('div', {
      staticClass: "column is-12"
    }, [_c('article', {
      staticClass: "media"
    })])]
  })], 2)]], 2) : _vm._e(), _vm._v(" "), _c('p', [(_vm.occurrence.email != null && parseInt(_vm.occurrence.user_id) == 1) ? [_c('small', {
    staticClass: "is-pulled-right"
  }, [_c('b', [_vm._v(_vm._s(_vm.occurrence.email_name) + " (" + _vm._s(_vm.occurrence.email) + ")")]), _vm._v(" at "), _c('b', [_vm._v(_vm._s(_vm.occurrence.created_at))])])] : [_c('small', {
    staticClass: "is-pulled-right"
  }, [_c('b', [_vm._v(_vm._s(_vm.occurrence.user.name))]), _vm._v(" at "), _c('b', [_vm._v(_vm._s(_vm.occurrence.created_at))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', {
    staticClass: "is-pulled-right"
  }, [_vm._v("Contact Name: "), _c('b', [_vm._v(_vm._s(_vm.occurrence.contact_name))]), _vm._v(" Contact Phone: "), _c('b', [_vm._v(_vm._s(_vm.occurrence.contact_phone))])])]], 2)])])])]), _vm._v(" "), _vm._l((_vm.occurrence.replies), function(reply, index) {
    return [(parseInt(reply.type) == 2) ? [(parseInt(_vm.$store.state.config.user.level) < 4) ? [_c('div', {
      staticClass: "column is-12"
    }, [_c('div', {
      staticClass: "card is-fullwidth tip"
    }, [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "card-content"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('pre', {
      domProps: {
        "innerHTML": _vm._s(reply.reply)
      }
    }), _vm._v(" "), (reply.files.length > 0) ? _c('article', {
      staticClass: "media"
    }) : _vm._e(), _vm._v(" "), (reply.files.length > 0) ? _c('article', {
      staticClass: "media"
    }, [(reply.showFiles == false) ? [_c('a', {
      staticClass: "button",
      on: {
        "click": function($event) {
          return _vm.loadFilesReply(reply, index)
        }
      }
    }, [_vm._m(3, true), _c('span', [_vm._v("Show attachments (" + _vm._s(reply.files.length) + ")")])])] : [_c('div', {
      staticClass: "columns is-multiline"
    }, [_vm._m(4, true), _vm._v(" "), _vm._l((reply.files), function(file) {
      return [_c('div', {
        staticClass: "column is-12",
        staticStyle: {
          "text-align": "center"
        }
      }, [(file['ext'].toLowerCase() == 'jpg' || file['ext'].toLowerCase() == 'gif' || file['ext'].toLowerCase() == 'png' || file['ext'].toLowerCase() == 'jpeg') ? [_c('a', {
        staticStyle: {
          "border-bottom": "none"
        },
        attrs: {
          "href": file['url'],
          "target": "_blank"
        }
      }, [_c('img', {
        attrs: {
          "src": file['url'],
          "alt": "",
          "width": "90%"
        }
      })])] : [_c('a', {
        staticStyle: {
          "border-bottom": "none"
        },
        attrs: {
          "href": file['url'],
          "target": "_blank"
        }
      }, [_c('i', {
        staticClass: "fa fa-file-o fa-4",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v("\n                                        " + _vm._s(file['name']) + "\n                                      ")])]], 2), _vm._v(" "), _c('div', {
        staticClass: "column is-12"
      }, [_c('article', {
        staticClass: "media"
      })])]
    })], 2)]], 2) : _vm._e(), _vm._v(" "), _c('p', [(_vm.occurrence.email != null && parseInt(reply.user_id) == 1) ? [_c('small', {
      staticClass: "is-pulled-right"
    }, [_c('b', [_vm._v(_vm._s(_vm.occurrence.email_name) + " (" + _vm._s(_vm.occurrence.email) + ")")]), _vm._v(" at "), _c('b', [_vm._v(_vm._s(reply.created_at))])])] : [_c('small', {
      staticClass: "is-pulled-right"
    }, [_c('b', [_vm._v(_vm._s(reply.user.name))]), _vm._v(" at "), _c('b', [_vm._v(_vm._s(reply.created_at))])])]], 2)])])])])] : _vm._e()] : [_c('div', {
      staticClass: "column is-12"
    }, [_c('div', {
      staticClass: "card is-fullwidth"
    }, [_c('div', {
      staticClass: "card-content"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('pre', {
      domProps: {
        "innerHTML": _vm._s(reply.reply)
      }
    }), _vm._v(" "), (reply.files.length > 0) ? _c('article', {
      staticClass: "media"
    }) : _vm._e(), _vm._v(" "), (reply.files.length > 0) ? _c('article', {
      staticClass: "media"
    }, [(reply.showFiles == false) ? [_c('a', {
      staticClass: "button",
      on: {
        "click": function($event) {
          return _vm.loadFilesReply(reply, index)
        }
      }
    }, [_vm._m(5, true), _c('span', [_vm._v("Show attachments (" + _vm._s(reply.files.length) + ")")])])] : [_c('div', {
      staticClass: "columns is-multiline"
    }, [_vm._m(6, true), _vm._v(" "), _vm._l((reply.files), function(file) {
      return [_c('div', {
        staticClass: "column is-12",
        staticStyle: {
          "text-align": "center"
        }
      }, [(file['ext'].toLowerCase() == 'jpg' || file['ext'].toLowerCase() == 'gif' || file['ext'].toLowerCase() == 'png' || file['ext'].toLowerCase() == 'jpeg') ? [_c('a', {
        staticStyle: {
          "border-bottom": "none"
        },
        attrs: {
          "href": file['url'],
          "target": "_blank"
        }
      }, [_c('img', {
        attrs: {
          "src": file['url'],
          "alt": "",
          "width": "90%"
        }
      })])] : [_c('a', {
        staticStyle: {
          "border-bottom": "none"
        },
        attrs: {
          "href": file['url'],
          "target": "_blank"
        }
      }, [_c('i', {
        staticClass: "fa fa-file-o fa-4",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v("\n                                      " + _vm._s(file['name']) + "\n                                    ")])]], 2), _vm._v(" "), _c('div', {
        staticClass: "column is-12"
      }, [_c('article', {
        staticClass: "media"
      })])]
    })], 2)]], 2) : _vm._e(), _vm._v(" "), _c('p', [(_vm.occurrence.email != null && parseInt(reply.user_id) == 1) ? [_c('small', {
      staticClass: "is-pulled-right"
    }, [_c('b', [_vm._v(_vm._s(_vm.occurrence.email_name) + " (" + _vm._s(_vm.occurrence.email) + ")")]), _vm._v(" at "), _c('b', [_vm._v(_vm._s(reply.created_at))])])] : [_c('small', {
      staticClass: "is-pulled-right"
    }, [_c('b', [_vm._v(_vm._s(reply.user.name))]), _vm._v(" at "), _c('b', [_vm._v(_vm._s(reply.created_at))])])]], 2)])])])])]]
  }), _vm._v(" "), (parseInt(_vm.$store.state.config.user.level) < 4 || _vm.occurrence.status != 3) ? _c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "card is-fullwidth"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "content"
  }, [(_vm.error !== '') ? _c('div', {
    staticClass: "notification is-danger"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "control is-vertical"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reply.reply),
      expression: "reply.reply"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    class: {
      'textarea': true,
      'is-danger': _vm.errors.has('reply')
    },
    attrs: {
      "name": "reply",
      "id": "reply",
      "placeholder": "",
      "data-vv-rules": "required"
    },
    domProps: {
      "value": (_vm.reply.reply)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reply, "reply", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('reply')),
      expression: "errors.has('reply')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('reply')))])])]), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('vue-dropzone', {
    ref: "dropzone",
    attrs: {
      "id": "dropzone",
      "options": _vm.dropzoneOptions
    },
    on: {
      "vdropzone-queue-complete": _vm.vdSuccess,
      "vdropzone-sending": _vm.vdSendingEvent
    }
  })], 1)]), _vm._v(" "), ((parseInt(_vm.$store.state.config.user.level) < 4) && (_vm.service.payment_services_v2 || _vm.service.invoice_services_v2)) ? [([14].includes(parseInt(_vm.occurrence.subject_type)) && !_vm.occurrence.dispute_id && ((_vm.service.payment_services_v2) || (_vm.service.invoice_services_v2))) ? _c('div', {
    staticClass: "is-clearfix"
  }, [_c('div', {
    staticClass: "control is-grouped"
  }, [((parseInt(_vm.service.dispute_v2) === 0) && _vm.occurrence.status !== 3 && !_vm.occurrence.financial_id) ? _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Address to")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dispute.address_to),
      expression: "dispute.address_to"
    }],
    staticClass: "select is-pulled-right",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dispute, "address_to", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Customer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Supplier")])])]) : _vm._e(), _vm._v(" "), ((parseInt(_vm.service.dispute_v2) === 0) && _vm.occurrence.status !== 3 && !_vm.occurrence.financial_id) ? _c('a', {
    class: {
      'button': true,
      'is-primary': true,
      'is-disabled': _vm.inProgress,
      'is-loading': _vm.inProgress
    },
    staticStyle: {
      "margin-top": "25px"
    },
    on: {
      "click": function($event) {
        return _vm.openDispute()
      }
    }
  }, [_vm._v("Open Dispute")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), ((!_vm.occurrence.financial_id && _vm.occurrence.status !== 3) && [1, 2, 3, 4, 6, 7, 8, 9, 11, 13, 17, 19, 31].includes(parseInt(_vm.occurrence.subject_type))) ? _c('charge', {
    attrs: {
      "occurrence": _vm.occurrence,
      "context": this
    }
  }) : _vm._e(), _vm._v(" "), (([18].includes(parseInt(_vm.occurrence.subject_type)) && !_vm.occurrence.financial_id)) ? _c('div', {
    staticClass: "is-clearfix"
  }, [_c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.charge.type),
      expression: "charge.type"
    }],
    staticClass: "select is-pulled-right",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.charge, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Commission")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Cre/Deb")])])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Address to")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.charge.address_to),
      expression: "charge.address_to"
    }],
    staticClass: "select is-pulled-right",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.charge, "address_to", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Supplier")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Customer")])])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Price")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.charge.price),
      expression: "charge.price"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ("required|decimal|min_value:1"),
      expression: "`required|decimal|min_value:1`"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('price')
    },
    attrs: {
      "name": "price",
      "id": "price",
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.charge.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.charge, "price", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('price')),
      expression: "errors.has('price')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('price')))])]), _vm._v(" "), (_vm.occurrence.status !== 3 && !_vm.occurrence.financial_id) ? _c('a', {
    class: {
      'button': true,
      'is-primary': true,
      'is-disabled': _vm.inProgress,
      'is-loading': _vm.inProgress
    },
    staticStyle: {
      "margin-top": "25px"
    },
    on: {
      "click": function($event) {
        return _vm.saveCreDeb(_vm.charge.address_to)
      }
    }
  }, [_vm._v("Save Charge")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (([20].includes(parseInt(_vm.occurrence.subject_type)) && !_vm.occurrence.financial_id)) ? _c('div', {
    staticClass: "is-clearfix"
  }, [_c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.charge.type),
      expression: "charge.type"
    }],
    staticClass: "select is-pulled-right",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.charge, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Commission")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Cre/Deb")])])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Price")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.charge.price),
      expression: "charge.price"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ("required|decimal|min_value:1"),
      expression: "`required|decimal|min_value:1`"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('price')
    },
    attrs: {
      "name": "price",
      "id": "price",
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.charge.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.charge, "price", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('price')),
      expression: "errors.has('price')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('price')))])]), _vm._v(" "), (_vm.occurrence.status !== 3 && !_vm.occurrence.financial_id) ? _c('a', {
    class: {
      'button': true,
      'is-primary': true,
      'is-disabled': _vm.inProgress,
      'is-loading': _vm.inProgress
    },
    staticStyle: {
      "margin-top": "25px"
    },
    on: {
      "click": function($event) {
        return _vm.saveCreDeb(1)
      }
    }
  }, [_vm._v("Save Charge")]) : _vm._e()])]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "is-clearfix"
  }, [(parseInt(_vm.$store.state.config.user.level) < 4) ? _c('a', {
    class: {
      'button': true,
      'is-info': true,
      'is-pulled-left': true,
      'is-disabled': _vm.errors.any() || _vm.inProgress,
      'is-loading': _vm.inProgress
    },
    on: {
      "click": _vm.internalTip
    }
  }, [_vm._v("Internal Tip")]) : _vm._e(), _vm._v(" "), (_vm.occurrence.status != 3 && _vm.occurrence.status != 6) ? _c('a', {
    class: {
      'button': true,
      'is-primary': true,
      'is-pulled-right': true,
      'is-disabled': _vm.errors.any() || _vm.inProgress,
      'is-loading': _vm.inProgress
    },
    on: {
      "click": _vm.replyOccurrence
    }
  }, [_vm._v("Reply")]) : _vm._e(), _vm._v(" "), (_vm.occurrence.status != 3 && _vm.occurrence.status != 6 && parseInt(_vm.$store.state.config.user.level) < 4) ? _c('a', {
    class: {
      'button': true,
      'is-danger': true,
      'is-pulled-right': true,
      'is-disabled': _vm.errors.any() || _vm.inProgress,
      'is-loading': _vm.inProgress
    },
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": _vm.replyCloseOccurrence
    }
  }, [_vm._v("Reply/Close")]) : _vm._e(), _vm._v(" "), (_vm.occurrence.status == 6 && _vm.$store.state.config.user.validate_charges) ? _c('a', {
    class: {
      'button': true,
      'is-success': true,
      'is-pulled-right': true,
      'is-disabled': _vm.errors.any() || _vm.inProgress,
      'is-loading': _vm.inProgress
    },
    on: {
      "click": function($event) {
        return _vm.validateCharge(true)
      }
    }
  }, [_vm._v("\n                    Approve\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.occurrence.status == 6 && _vm.$store.state.config.user.validate_charges) ? _c('a', {
    class: {
      'button': true,
      'is-danger': true,
      'is-pulled-right': true,
      'is-disabled': _vm.errors.any() || _vm.inProgress,
      'is-loading': _vm.inProgress
    },
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.validateCharge(false)
      }
    }
  }, [_vm._v("\n                    Not Approve\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.occurrence.status < 3 && parseInt(_vm.$store.state.config.user.level) < 4) ? _c('a', {
    class: {
      'button': true,
      'is-warning': true,
      'is-pulled-right': true,
      'is-loading': _vm.inProgress,
      'is-disabled': _vm.inProgress
    },
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": _vm.replyAnalysis
    }
  }, [_vm._v("Under Analysis")]) : _vm._e()])], 2)])])]) : _vm._e()], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), (((parseInt(_vm.$store.state.config.user.level) == 3 || parseInt(_vm.$store.state.config.user.level) == 2)) && (parseInt(_vm.service.dispute_v2) !== 0)) ? _c('dispute', {
    attrs: {
      "service": _vm.service
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (parseInt(_vm.$store.state.config.user.level) < 99) ? _c('financial', {
    attrs: {
      "service": _vm.service
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (parseInt(_vm.$store.state.config.user.level) < 99) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-heading panel-heading-info",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_vm._v("History Financial\n            "), _c('button', {
    staticClass: "button is-success is-small",
    on: {
      "click": function($event) {
        return _vm.loadHistoryFinancial()
      }
    }
  }, [_vm._v("Load history")])]), _vm._v(" "), (_vm.load_history_financial === 1) ? _c('p', {
    staticClass: "panel-block"
  }, [_c('historyFinancial', {
    attrs: {
      "service": _vm.service
    }
  })], 1) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (parseInt(_vm.$store.state.config.user.level) < 99) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "panel-success"
  }, [_c('p', {
    staticClass: "panel-heading panel-heading-success",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_vm._v("History Extend\n            "), _c('button', {
    staticClass: "button is-info is-small",
    on: {
      "click": function($event) {
        return _vm.loadHistoryExtend()
      }
    }
  }, [_vm._v("Load history")])]), _vm._v(" "), (_vm.load_history_extend === 1) ? _c('p', {
    staticClass: "panel-block"
  }, [_c('historyExtend', {
    attrs: {
      "service": _vm.service
    }
  })], 1) : _vm._e()])])]) : _vm._e()], 1)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-paperclip",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-12"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('i', {
    staticClass: "fa fa-paperclip",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Attachments")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "card-header is-primary",
    staticStyle: {
      "box-shadow": "0 1px 0px #2366d1, 0 0 0 0px #2366d1",
      "background-color": "#2366d1"
    }
  }, [_c('p', {
    staticClass: "card-header-title is-primary",
    staticStyle: {
      "color": "#FFFFFF"
    }
  }, [_vm._v("Internal Tip")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-paperclip",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-12"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('i', {
    staticClass: "fa fa-paperclip",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Attachments")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-paperclip",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-12"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('i', {
    staticClass: "fa fa-paperclip",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Attachments")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title is-primary"
  }, [_vm._v("Reply")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0369e5b8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/occurrences/Occurrence.vue
// module id = 1055
// module chunks = 39